export const STATIONS = {
  "moscow-tov": "Москва-Товарная",
  "spb-vitebsky": "Санкт-Петербург-Витебский",
  "ekb-sort": "Екатеринбург-Сортировочный",
  "novosib-glav": "Новосибирск-Главный",
};

export const RAILWAYS = {
  moscow: "Московская ж.д.",
  october: "Октябрьская ж.д.",
  sverdlovsk: "Свердловская ж.д.",
  "west-siberian": "Западно-Сибирская ж.д.",
  АЗБ: "Азербайджанская железная дорога",
  АРМ: "Армянская железная дорога",
  БЛР: "Белорусская железная дорога",
  ГРЗ: "Грузинская железная дорога",
  ДЗР: "Донецкая железная дорога",
  ДНП: "Днепровская железная дорога",
  КАЗ: "Казахстанские железные дороги",
  КИР: "Киргизская железная дорога",
  ЛВВ: "Львовская железная дорога",
  ЛИТ: "Литовские железные дороги",
  ЛАТ: "Латвийская железная дорога",
  МДВ: "Молдавская железная дорога",
  ОДС: "Одесская железная дорога",
  ПИВ: "Пивденная железная дорога",
  ТДЖ: "Таджикская железная дорога",
  УЗБ: "Узбекская железная дорога",
  УКР: "Украинская железная дорога",
  ХАР: "Харьковская железная дорога",
  ЭСТ: "Эстонская железная дорога",
  ЗАК: "Закавказская железная дорога",
  МОС: "Московская железная дорога",
  СПБ: "Санкт-Петербург-Главный",
  РЖД: "Российские железные дороги",
  АЗР: "Азовская железная дорога",
  ДОН: "Донецкая железная дорога",
  БЧ: "Белорусская железная дорога",
  БЕЛ: "Белорусская железная дорога",
  КЗХ: "Казахстанские железные дороги",
  ЮКЖД: "Южно-Казахстанская железная дорога",
  ГР: "Грузинская железная дорога",
  АЗ: "Азербайджанская железная дорога",
};

// Utility function to format station display as "Station Name (Railway Abbreviation)"
export const formatStationDisplay = (stationCode: string, railwayCode?: string) => {
  const stationName = STATIONS[stationCode as keyof typeof STATIONS] || stationCode;
  if (!railwayCode) {
    return stationName;
  }
  return `${stationName} (${railwayCode})`;
};

export const CARGO_TYPES = {
  coal: "Каменный уголь",
  grain: "Зерно пшеницы",
  metal: "Металлопрокат",
  containers: "Контейнеры",
};

export const ETSNGS_CODES = {
  coal: "11110",
  grain: "11210",
  metal: "42000",
  containers: "99999",
};

export const WAGON_TYPES = {
  tank_car: "Цистерна",
  gondola_car: "Полувагон",
  covered_wagon: "Крытый вагон",
  platform: "Платформа",
  hopper_car: "Хоппер-дозатор",
  refrigerator_car: "Рефрижераторный вагон",
  special_car: "Специальный вагон",
};

export const WAGON_MODELS = ["12-132", "19-752", "11-217", "13-401", "19-923", "14-1251"];

export const WAGON_CARRYINGS = [69, 61, 68, 70, 70, 44];
export const WAGON_VOLUMES = [88, 73, 120, 0, 94, 92];
export const WAGON_LENGTHS = [13.4, 14.7, 14.73, 14.62, 17.35, 14.73];
export const WAGON_DESCRIPTIONS = [
  "Универсальный полувагон для насыпных грузов",
  "Цистерна для нефтепродуктов",
  "Универсальный крытый вагон",
  "Универсальная платформа",
  "Хоппер для зерна",
  "Изотермический вагон для скоропортящихся грузов",
];

export const STATUS_LABELS = {
  draft: "Черновик",
  review: "На модерации",
  revision: "На доработке",
  waiting_trading: "Ожидает",
  collecting_offers: "Сбор предложений",
  trading_active: "Сбор предложений",
  retrading: "Переторжка",
  final_evaluation: "Подведение итогов",
  trading_completed: "Подведение итогов",
  winner_selected: "Завершена",
  completed: "Завершена",
  cancelled: "Отменена",
};

export const STATUS_COLORS = {
  draft: "bg-gray-100 text-gray-800",
  review: "bg-amber-100 text-amber-800",
  revision: "bg-yellow-100 text-yellow-800",
  waiting_trading: "bg-blue-100 text-blue-800",
  collecting_offers: "bg-green-100 text-green-800",
  trading_active: "bg-green-100 text-green-800",
  retrading: "bg-orange-100 text-orange-800",
  final_evaluation: "bg-purple-100 text-purple-800",
  trading_completed: "bg-purple-100 text-purple-800",
  winner_selected: "bg-slate-100 text-slate-800",
  completed: "bg-slate-100 text-slate-800",
  cancelled: "bg-red-100 text-red-800",
};

export const TRADING_STAGES = {
  stage_1: "Этап 1 – Сбор предложений",
  stage_2: "Этап 2 – Переторжка",
  stage_3: "Этап 3 – Подведение итогов",
};

export const TRADING_STAGE_COLORS = {
  stage_1: "bg-green-100 text-green-800",
  stage_2: "bg-orange-100 text-orange-800",
  stage_3: "bg-purple-100 text-purple-800",
};

export const ROLE_LABELS = {
  cargo_owner: "Грузовладелец",
  wagon_owner: "Собственник вагона",
  admin: "Модератор",
};

// Enum ролей пользователя (значения соответствуют OpenAPI: ADMIN, CARGO_OWNER, WAGON_OWNER)
export enum UserRoleEnum {
  Admin = "ADMIN",
  CargoOwner = "CARGO_OWNER",
  WagonOwner = "WAGON_OWNER",
}

export const TARIFF_LABELS = {
  WITH_20_VAT: "в том числе НДС 22%",
  WITH_0_VAT: "в том числе НДС 0%",
  WITH_OUT_VAT: "Без НДС",
  COEFFICIENT: "Коэффициент",
} as const;

export enum TariffLabelsEnum {
  With20Vat = "в том числе НДС 22%",
  With0Vat = "в том числе НДС 0%",
  WithOutVat = "Без НДС",
  Coefficient = "Коэффициент",
}
